import React, { useEffect, useRef } from 'react';
import { StyledScrollbar } from '../styles/StyledScrollbarDiv';

interface HorizontalScrollProps extends React.HTMLAttributes<HTMLDivElement> {}
const HorizontalScroll: React.FC<HorizontalScrollProps> = (props) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleWheel = (event: WheelEvent) => {
      if (scrollRef.current) {
        event.preventDefault();
        scrollRef.current.scrollLeft += event.deltaY;
      }
    };

    const scrollElement = scrollRef.current;

    if (scrollElement) {
      scrollElement.addEventListener('wheel', handleWheel, { passive: false });
    }

    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener('wheel', handleWheel);
      }
    };
  }, []);

  return <StyledScrollbar ref={scrollRef} {...props} />;
};

export default HorizontalScroll;